/**
 * Expertise rules for classes that grant expertise (Rogue, Bard).
 */

/** Levels at which each class grants expertise (2 skills per grant). */
const EXPERTISE_LEVELS: Record<string, number[]> = {
  rogue: [1, 6],   // 2 at level 1, 2 more at level 6
  bard: [3, 10],   // 2 at level 3, 2 more at level 10
};

/**
 * Get max expertise skills allowed for a class at a given level.
 */
export function getExpertiseAllowed(classId: string, level: number): number {
  const levels = EXPERTISE_LEVELS[classId];
  if (!levels) return 0;

  let count = 0;
  for (const reqLevel of levels) {
    if (level >= reqLevel) {
      count += 2;
    }
  }
  return count;
}

/**
 * Check if a class has the expertise feature.
 */
export function hasExpertise(classId: string): boolean {
  return classId in EXPERTISE_LEVELS;
}

/**
 * Get the level at which expertise becomes available for a class.
 */
export function getExpertiseLevel(classId: string): number | null {
  const levels = EXPERTISE_LEVELS[classId];
  return levels ? levels[0] : null;
}
